import React from "react";
import { Header, Sidebar, AuthenticateDashboard , NewSidebar} from "../../common";
import { Outlet } from "react-router-dom";

const Dashboard = () => {
  return (
    <div className="h-screen flex flex-col">
      <Header />
      <div className="dashboard flex flex-grow overflow-hidden">
        {/* Sticky Sidebar */}
        <div className="flex-shrink-0 overflow-y-auto">
          <NewSidebar />
        </div>
        
        {/* Scrollable Content Area */}
        <div className="flex-1 overflow-y-auto relative">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AuthenticateDashboard(Dashboard);